import React from 'react'

type ToggleSwitchProps = {
    isOn: boolean
    handleToggle?: () => void
    activeColor: string
    inactiveColor: string
    switchWidth?: number
    switchHeight?: number
    btnWidth?: number
    btnHeight?: number
    children?: React.ReactNode
}

function ToggleSwitch({
    isOn,
    handleToggle = () => {},
    activeColor,
    inactiveColor,
    switchWidth = 40,
    switchHeight = 24,
    btnWidth = 22,
    btnHeight = 22,
    children = null
}: ToggleSwitchProps) {
    const knobTranslateX = isOn ? switchWidth - btnWidth - 2 : 0
    const background = isOn ? activeColor : inactiveColor

    return (
        <div
            onClick={handleToggle}
            style={{
                position: 'relative',
                display: 'inline-block',
                cursor: 'pointer',
                borderRadius: 12,
                backgroundColor: background,
                width: `${switchWidth}px`,
                height: `${switchHeight}px`
            }}
        >
            <div
                style={{
                    position: 'absolute',
                    left: '1px',
                    top: '1px',
                    width: `${btnWidth}px`,
                    height: `${btnHeight}px`,
                    borderRadius: '50%',
                    background: '#FFFFFF',
                    transform: `translateX(${knobTranslateX}px)`,
                    transition: '0.4s'
                }}
            />
            {children}
        </div>
    )
}

export default ToggleSwitch


